import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Layout, PageHeader } from "@/components/Layout";
import { Seo } from "@/components/Seo";
import { RotatingImage } from "@/components/RotatingImage";
import { RichText } from "@/components/RichText";

export default function About() {
  const [site, setSite] = useState(null);
  useEffect(() => {
    api.get("/site").then((r) => setSite(r.data)).catch(() => {});
  }, []);

  const aboutImages = site?.about_images?.length ? site.about_images : (site?.about_image ? [site.about_image] : []);

  return (
    <Layout>
      <Seo title="About Quinte BCA Pool League | Trenton, Ontario" description="Learn about the Quinte BCA Pool League — recreational 8-ball and 9-ball competition, divisions and community in Trenton and the Quinte region." path="/about" />
      <PageHeader eyebrow="Who we are" title={site?.about_title || "About the League"} />
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16">
        {aboutImages.length > 0 && (
          <RotatingImage images={aboutImages} alt="League" className="w-full h-80 rounded-lg shadow-md mb-10" testid="about-rotating" />
        )}
        {site?.about_text && <RichText html={site.about_text} className="text-lg" testid="about-text-view" />}
      </div>
    </Layout>
  );
}
